import $ from 'jquery'
import nprogress from 'nprogress'

class Progress {
  constructor () {
    this.counter = 0

    nprogress.configure({
      minimum: 0.16,
      speed: 200,
      trickleRate: 0.1,
      trickleSpeed: 250,
    })

    $(document)
      .bind('ajaxStart', () => this.start())
      .bind('ajaxComplete', () => this.done())
  }

  use (axios) {
    axios.interceptors.request.use(config => {
      // Do something before request is sent
      this.start()
      return config
    }, error => {
      // Do something with request error
      return Promise.reject(error)
    })

    axios.interceptors.response.use(response => {
      // Do something with response data
      this.done()
      return response
    }, error => {
      // Do something with response error
      this.done()
      return Promise.reject(error)
    })
  }

  start () {
    if (this.counter === 0) {
      nprogress.start()
    } else {
      nprogress.inc()
    }
    this.counter++
  }

  done () {
    setTimeout(() => {
      this.counter--
      if (this.counter === 0) {
        nprogress.done()
      } else {
        nprogress.inc()
      }
    }, 100)
  }
}

export default new Progress()



// WEBPACK FOOTER //
// ./resources/assets/js/nprogress.js